export enum SignatureType {
    Paper = 0,
    ESign = 1,
}
